
'use strict';

define('component!settings/ExtensionVoucherTabComponent',['require','prop-types','react','create-react-class','translate','underscore','lib/Podio.Config','component!Spinner','services/OrganizationService','services/ExtensionVoucherService','lib/Podio.Utils','lib/Podio.Routes','lib/Podio.Time','classnames'],function (require) {
  'use strict';

  var PropTypes = require('prop-types');

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var t = require('translate');
  var _ = require('underscore');

  var podioConfig = require('lib/Podio.Config');

  var SpinnerComponent = require('component!Spinner');
  var OrganizationService = require('services/OrganizationService');
  var ExtensionVoucherService = require('services/ExtensionVoucherService');

  var utils = require('lib/Podio.Utils');
  var routes = require('lib/Podio.Routes');
  var PodioTime = require('lib/Podio.Time');

  var classNames = require('classnames');

  var AGREEMENT_TEXT = t('Please note, that these extensions are not part of the Podio product and are not built by Progress. By redeeming a voucher you create a new account with an external Podio Partner. The vouchers cannot be added to existing contracts with these partners. They are valid for the duration specified below, and the conditions of each voucher may vary. Progress does not guarantee the services that our partners provide. #extension_vouchers_piesync');

  var ExtensionVoucherTabComponent = ReactCreateClass({
    displayName: 'ExtensionVoucherTabComponent',

    getInitialState: function getInitialState() {
      return {
        organizations: [],
        currentOrganization: null,
        isInitialLoading: true,
        extensions: []
      };
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var _this = this;

      OrganizationService.getOrganizations().then(function (organizations) {
        if (organizations.length === 0) {
          return;
        }

        _this.setState({
          organizations: organizations,
          currentOrganization: organizations[0],
          isInitialLoading: false
        }, _this.fetchExtensionVouchers);
      });
    },

    render: function render() {
      var _this2 = this;

      if (this.state.isInitialLoading) {
        return null;
      }

      var extensions = this.state.extensions;

      var extensionIds = Object.keys(extensions);
      var allRequirementsPassed = extensionIds.every(function (id) {
        return extensions[id].requirements_passed;
      });

      var agreementNotAccepted = !allRequirementsPassed && extensionIds.some(function (id) {
        return extensions[id].requirements.operands.some(function (_ref) {
          var description = _ref.description;
          var requirement_passed = _ref.requirement_passed;
          return description === 'agreement_accepted' && requirement_passed === false;
        });
      });

      var acceptAgreementButton = agreementNotAccepted ? React.createElement(
        'a',
        { id: 'agreement', onClick: this.handleAgreementClick,
          className: 'extension-voucher-tab-component__agreement-button button-new secondary', href: '#' },
        t('I have read and I agree')
      ) : null;

      var extensionElements = extensionIds.map(function (id) {
        var extensionData = _this2.props.extensionData[id];
        if (!extensionData) {
          return null;
        }
        // do not show extension if feature flag is explicitly defined and then disabled
        if (extensionData.can_show === false) {
          return null;
        }
        var extension = extensions[id];
        var extensionDisabled = !extensions[id].requirements_passed;

        var className = classNames('extension-redeemer-component', {
          'extension-redeemer-component--disabled': extensionDisabled
        });

        // First, flatten failed requirements.
        // Then map() over each to produce a list of formatted sentences to display to the user.
        var requirementsText = extension.requirements.operands.reduce(function (prev, operand) {
          if (operand.requirement_passed) {
            return prev;
          } else if (operand.operands) {
            if (operand.operands.some(function (operand) {
              return operand.requirement_passed;
            })) {
              return prev;
            } else {
              return prev.concat([{
                description: operand.operands.reduce(function (prev, operand) {
                  return prev.concat([operand.description]);
                }, []).join('__'),
                operands: operand.operands
              }]);
            }
          } else {
            return prev.concat([operand]);
          }
        }, []).map(function (requirement) {
          var text = function text() {
            switch (requirement.description) {
              case 'agreement_accepted':
                return t('Please accept agreement #extension_vouchers');

              case 'price_tiers':
                return t('Only available on the following price tier(s): {0}. #extension_vouchers').format(requirement.allowed_values.join(', '));

              case 'employee_space_member_roles':
                return t('Only available to users with the following role(s): {0}. #extension_vouchers').format(requirement.allowed_values.join(', '));

              case 'user_is_contract_owner':
                return t('Only available to contract owners. #extension_vouchers');

              case 'invoice_intervals':
                {
                  var _ret = (function () {
                    var valuesFormatted = {
                      1: t('monthly #extension_vouchers'),
                      12: t('annual #extension_vouchers')
                    };

                    return {
                      v: t('Only available to contracts with {0} plan(s). #extension_vouchers').format(requirement.allowed_values.map(function (interval) {
                        return valuesFormatted[interval];
                      }).join(' ' + t('or #extension_vouchers') + ' '))
                    };
                  })();

                  if (typeof _ret === 'object') return _ret.v;
                }
              case 'organization_types':
                {
                  var allowed_values = requirement.allowed_values.map(function (val) {
                    return val === 'premium' ? 'paid' : val;
                  });

                  return t('Only available to organizations on {0} plan(s). #extension_vouchers').format(allowed_values.join(', '));
                }
              case 'employee_space_member_roles__user_is_contract_owner':
              case 'user_is_contract_owner__employee_space_member_roles':
                return t('Only available to users with {0} role(s) and contract owners. #extension_vouchers').format(requirement.operands[0].allowed_values.join(', '));
              case 'rebate_reason_types':
                return t('Not available on {0} plan. #extension_vouchers').format(requirement.actual_values[0]);

              default:
                return requirement.description;
            }
          };
          return React.createElement(
            'li',
            { key: requirement.description },
            text()
          );
        });

        var actionElement = extension.status === 'requested' ? React.createElement(
          'a',
          { disabled: extensionDisabled, className: 'button-new secondary', target: '_blank', href: extensionData.link.url },
          t('Continue to {0} #extension_vouchers').format(extensionData.name)
        ) : extension.status === 'redeemed' ? React.createElement(
          'div',
          { className: 'extension-redeemer-component__valid' },
          React.createElement(
            'label',
            null,
            t('Active until #extension_vouchers')
          ),
          React.createElement(
            'p',
            null,
            PodioTime.localMomentFromString(extension.valid_until).format('LL')
          )
        ) : React.createElement(
          'button',
          { disabled: extensionDisabled, className: 'button-new primary',
            onClick: function () {
              return _this2.handleRedeemExtension(id);
            } },
          t('Redeem voucher #extension_vouchers')
        );

        return React.createElement(
          'div',
          { className: className, key: id },
          React.createElement(
            'section',
            { className: 'extension-redeemer-component__logo' },
            React.createElement('img', { className: 'extension__logo', src: extensionData.logo, alt: extensionData.name })
          ),
          React.createElement(
            'section',
            { className: 'extension-redeemer-component__content' },
            React.createElement(
              'h4',
              { className: 'extension-redeemer-component__name' },
              extensionData.name
            ),
            React.createElement(
              'p',
              null,
              extensionData.description
            ),
            React.createElement(
              'ul',
              { className: 'extension-redeemer-component__requirements' },
              requirementsText
            )
          ),
          React.createElement(
            'section',
            { className: 'extension-redeemer-component__action' },
            actionElement
          )
        );
      });

      var orgSelector = this.state.organizations.length > 0 ? React.createElement(
        'section',
        { className: 'extension-voucher-tab-component__organization-selector' },
        React.createElement(
          'label',
          { className: 'extension-voucher-tab-component__organization-selector-label' },
          t('Organization #extension_vouchers')
        ),
        React.createElement(
          'select',
          {
            className: 'extension-voucher-tab-component__organization-selector-select styled',
            onChange: this.handleOrgSelectChange,
            id: 'orgSelect',
            value: this.state.currentOrganization.org_id },
          this.state.organizations.map(function (org, index) {
            return React.createElement(
              'option',
              { key: index, value: org.org_id },
              org.name
            );
          })
        )
      ) : null;

      return React.createElement(
        'div',
        { className: 'extension-voucher-tab-component' },
        this.state.isInitialLoading ? React.createElement(SpinnerComponent, null) : orgSelector,
        React.createElement(
          'header',
          { className: 'extension-voucher-tab-component__header' },
          React.createElement(
            'div',
            { id: 'message', className: 'extension-voucher-tab-component__header-message' },
            React.createElement(
              'p',
              null,
              AGREEMENT_TEXT
            ),
            acceptAgreementButton
          )
        ),
        React.createElement(
          'main',
          { className: 'extension-voucher-tab-component__extensions' },
          React.createElement(
            'header',
            null,
            t('Extension vouchers #extension_vouchers')
          ),
          extensionElements,
          React.createElement(
            'footer',
            null,
            t("Check out the #extension_vouchers"),
            React.createElement(
              'a',
              { href: routes.extensions_path({ format: 'html' }), target: '_blank' },
              t("complete list of extensions #extension_vouchers")
            ),
            t("available to make your Podio experience even better #extension_vouchers")
          )
        )
      );
    },

    fetchExtensionVouchers: function fetchExtensionVouchers() {
      var _this3 = this;

      ExtensionVoucherService.getExtensionVouchers(this.state.currentOrganization.org_id).then(function (extensions) {
        var objExtensions = _.object(extensions.map(function (extension) {
          return [extension.extension_voucher.name, extension];
        }));

        _this3.setState({ extensions: objExtensions, isInitialLoading: false });
      });
    },

    handleAgreementClick: function handleAgreementClick() {
      var _this4 = this;

      ExtensionVoucherService.acceptAgreement(this.state.currentOrganization.org_id).then(function (agreement) {
        _this4.fetchExtensionVouchers();
      });
    },

    handleOrgSelectChange: function handleOrgSelectChange(e) {
      var selectedOrg = _.find(this.state.organizations, function (organization) {
        return organization.org_id === parseInt(e.target.value);
      });

      this.setState({
        currentOrganization: selectedOrg,
        isInitialLoading: true
      }, this.fetchExtensionVouchers);
    },

    handleRedeemExtension: function handleRedeemExtension(extensionId) {
      var _this5 = this;

      var extensionVoucher = this.state.extensions[extensionId].extension_voucher;

      ExtensionVoucherService.redeemExtensionVoucher(extensionVoucher.extension_voucher_id, {
        org_id: this.state.currentOrganization.org_id
      }).then(function (extensionRedeem) {
        var extensions = _.clone(_this5.state.extensions);
        extensions[extensionId] = extensionRedeem;

        _this5.setState({
          extensions: extensions
        });
      });
    }
  });

  ExtensionVoucherTabComponent.propTypes = {
    extensionData: PropTypes.object
  };

  ExtensionVoucherTabComponent.defaultProps = {
    extensionData: {
      plecto: {
        name: 'Plecto',
        logo: '/images/components/ExtensionRedeemerComponent/plecto.png',
        description: t('Customizable dashboards showing data all across your Podio apps. #extension_vouchers'),
        link: { url: 'https://app.plecto.com/social/login/podio/', humanized: 'plecto.com' }
      },
      smrtPhone: {
        name: 'smrtPhone',
        logo: '/images/components/ExtensionRedeemerComponent/smrtPhone_logo.png',
        description: t('Instant phone numbers, multi-line power dialer, customized call routing, IVR, text messaging, user management, call monitoring, call recording and logging to Podio. New accounts get $100 of instant credit. #extension_vouchers'),
        link: { url: 'https://phone.smrt.studio/addCredit/' + podioConfig.smrtPhone, humanized: 'smrtphone.io' }
      }
    }
  };

  return ExtensionVoucherTabComponent;
});
